// extracted by mini-css-extract-plugin
module.exports = {"priceInput":"InputPrice_priceInput__WfJJR"};